export default function uuid4() {
  return window.crypto.randomUUID();
}
